var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164455",
    "data-name": "Rectangle 164455",
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164456",
    "data-name": "Rectangle 164456",
    width: 15,
    height: 15,
    transform: "translate(0.054 0.054)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182683",
    "data-name": "Group 182683",
    transform: "translate(-2424 -936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182687",
    "data-name": "Group 182687",
    transform: "translate(2424 936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182684",
    "data-name": "Group 182684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182683-2",
    "data-name": "Group 182683",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98636",
    "data-name": "Path 98636",
    d: "M11.489,0A11.489,11.489,0,1,0,22.978,11.489,11.489,11.489,0,0,0,11.489,0",
    fill: "#b7cfd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182686",
    "data-name": "Group 182686",
    transform: "translate(3.946 3.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182685",
    "data-name": "Group 182685",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98637",
    "data-name": "Path 98637",
    d: "M63.383,62.224l-.628-1.655a7.251,7.251,0,1,0-2.167,2.164l1.656.63,1.837.7Z",
    transform: "translate(-49.132 -49.111)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(2432 952)",
    fill: "#416574",
    fontSize: 12,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/new-chat-icon.62c106396a5adb781c3d52ed012707e6.svg";
export { ForwardRef as ReactComponent };